<template>
  <span
    class="rounded-full caption inline-flex items-center gap-3 px-6 py-2"
    :class="{
      'bg-static-default-mid text-static-default-hi': theme === 'default',
      'bg-action-default-hi text-static-light-hi': theme === 'dark',
    }"
  >
    <component :is="icon" v-if="icon" class="-ml-1" size="12" />
    <slot />
  </span>
</template>

<script setup lang="ts">
import type { Component } from 'vue'

const { theme = 'default' } = defineProps<{
  icon?: Component
  theme?: 'default' | 'dark'
}>()
</script>
